var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column justify-content-center align-items-center",attrs:{"id":"header"}},[_c('div',{attrs:{"id":"ibisstylesLogo"}}),_vm._v(" "),_c('div',{attrs:{"id":"date"}},[_vm._v(_vm._s(_vm.date))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b1ee4c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ibisstyles/rates/horizontal/v1/header.vue
// module id = Cd9K
// module chunks = 0